import Grid from '@zenbusiness/zui/Grid';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const TasksGrid = superstyled({
  tag: Grid,
  name: 'IncludedInPlan',
  slot: 'TasksGrid',
  styles: { paddingTop: '16px' },
});

export const DescriptionText = superstyled({
  tag: Text,
  name: 'IncludedInPlan',
  slot: 'DescriptionText',
  styles: ({ theme }) => ({ color: theme.palette.text.secondary }),
});
